<template>
  <div class="row justify-content-center align-items-center">
    <div class="col-md-8 col-sm-12 col-s-8 col-xl-8 col-xxl-6">
      <ErrorDisplay
        v-if="error"
        :error="error"
        @clear="error = ''"
      />
      <ResultDisplay
        v-if="!error"
        :request-id="requestId"
        :done="done"
        :last-log-line="lastLogLine"
        :result="result"
        :log="log"
        @reset="reset"
      />
    </div>
  </div>
</template>

<script>
import ResultDisplay from '../components/ResultDisplay.vue'
import ErrorDisplay from '../components/ErrorDisplay.vue'

export default {
  name: 'ResultPage',
  components: {
    ResultDisplay,
    ErrorDisplay
  },
  props: {
    requestId: {
      type: String,
      required: true
    },
    cached: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      done: false,
      lastLogLine: this.cached ? "Cached result." : "Retreiving request...",
      result: "",
      log: "",
      interval: null,
      error: ""
    }
  },
  mounted() {
    this.startPolling()
  },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    reset() {
      this.$router.push({ name: 'input' })
    },
    startPolling() {
      this.interval = setInterval(async () => {
        try {
          const response = await fetch('/laniakea?q=getRequest&request_id=' + this.requestId)
          const data = await response.json()
          if (data.status === "success") {
            const logLines = data.data.log.split(/\n/)
            this.lastLogLine = logLines[logLines.length - 2] || ''
            this.result = data.data.result
            this.log = data.data.log

            if (data.data.status === "success" || data.data.status === "error") {
              this.done = true
              clearInterval(this.interval)
            }
          }
          if(data.status === "error") {
            this.error = data.data
            clearInterval(this.interval)
          }
        } catch (error) {
          console.error('Polling failed:', error)
          this.error = 'Failed to fetch request status'
          clearInterval(this.interval)
        }
      }, 1000)
    }
  }
}
</script>